import {naturalComparator} from 'helpers/naturalSort';
import useParseURL from './useParseURL';

export const useGetNaturalComparator = () => {
  const {language} = useParseURL();
  return naturalComparator(language);
};
